module.exports = __webpack_public_path__ + "media/images/top/img_new-c1ef84d07c8573c561679e4ec004b4ea.png";